import { escapeHtml } from '@shared/utils/escapeHtml'

// Returns HTML for v-html: the title is escaped piece by piece, so only the
// highlight tags are markup.
export default (needle, title) => {
  if (typeof needle !== 'string' || typeof title !== 'string') {
    return ''
  }

  if (!needle.length || !title.length) {
    return ''
  }

  // WARN: To correct the regex
  const escapedNeedle = needle.replace(/([[\]{}()/\\^$?:=+\-&><.*%])/g, '\\$1')
  const searchPattern = new RegExp(`(${escapedNeedle})`, 'gi')
  // Splitting on a capturing group puts the matches at the odd indexes.
  const parts = title.split(searchPattern)
  if (parts.length === 1) return ''

  return parts
    .map((part, index) =>
      index % 2 ? `<strong>${escapeHtml(part)}</strong>` : escapeHtml(part),
    )
    .join('')
}
